import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from '../components/ui/button';
import { useScrolled } from '../hooks/useAppHooks';

const NAV_LINKS = [
  { id: 'nav-about', label: 'About', href: '#about' },
  { id: 'nav-services', label: 'Services', href: '#services' },
  { id: 'nav-praise', label: 'Praise', href: '#praise' },
  { id: 'nav-faq', label: 'FAQ', href: '#faq' },
  { id: 'nav-mixes', label: 'Mixes', href: '#mixes' },
];

function DesktopNav() {
  return (
    <nav className="hidden md:flex items-center gap-8">
      {NAV_LINKS.map((l) => (
        <a
          key={l.id}
          href={l.href}
          className="font-mono text-[11px] tracking-[0.2em] text-white/70 hover:text-violet-300 transition-colors uppercase"
        >
          {l.label}
        </a>
      ))}
      <Button
        asChild
        className="bg-violet-400 text-[#1a0b2e] hover:bg-violet-300 rounded-none font-mono text-[11px] tracking-[0.2em] px-5 h-9"
      >
        <a href="#cta">BOOK YKAS</a>
      </Button>
    </nav>
  );
}

function MobileMenu({ open, onClose }) {
  if (!open) return null;
  return (
    <div className="md:hidden bg-[#0a0612]/98 border-t border-violet-500/10 px-6 py-4 space-y-3">
      {NAV_LINKS.map((l) => (
        <a
          key={l.id}
          href={l.href}
          onClick={onClose}
          className="block font-mono text-xs tracking-[0.2em] text-white/70 uppercase"
        >
          {l.label}
        </a>
      ))}
      <a
        href="#cta"
        onClick={onClose}
        className="block font-mono text-xs tracking-[0.2em] text-violet-300 uppercase pt-2"
      >
        Book YKAS →
      </a>
    </div>
  );
}

export default function Header() {
  const scrolled = useScrolled(20);
  const [open, setOpen] = useState(false);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-[#0a0612]/85 backdrop-blur-md border-b border-violet-500/10' : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1440px] mx-auto px-6 lg:px-12 h-[72px] flex items-center justify-between">
        <a href="#top" className="flex flex-col">
          <span className="font-display text-xl tracking-wider text-violet-300">DJ YKAS</span>
          <span className="font-mono text-[10px] tracking-[0.25em] text-violet-400/50 -mt-0.5">
            FEEL THE RHYTHM
          </span>
        </a>

        <DesktopNav />

        <button className="md:hidden text-violet-300" onClick={() => setOpen(!open)} aria-label="menu">
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      <MobileMenu open={open} onClose={() => setOpen(false)} />
    </header>
  );
}
